import {CHART_OPTIONS, FLATTENED_CHART_TYPES} from './constants';

export function formattedChartName(type, style) {
  return CHART_OPTIONS[type][style].name;
}

export function isFlattenedData(chartType) {
  return FLATTENED_CHART_TYPES.includes(chartType);
}
